import React from 'react';
import styled from 'styled-components';

const CategoriesTitle = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="categories-header1">
          <p className="categories-text1 my-auto ps-lg-5 ps-0">Categories</p>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  // padding: 20px 0;

  .container {
    max-width: 1135px;
    width: 100%;
    // margin:  auto;
    // height: auto;
    padding: 0px 0;
  }

  
    .categories-text1 {
      font-size: 20px;
      font-weight: bold;
      color: #ef4766;
      margin: 0 !important;
      // height: auto;
    }
  

  @media (max-width: 480px) {
  padding: 0px 0;
    .categories-text1 {
      font-size: 18px;
      
    }

    .container {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  @media (max-width: 368px) {
  padding: 0px 0;
    .categories-text1 {
      font-size: 15px !important;
    }

    .container {
      padding: 0 !important;
    }
  }
`;

export default CategoriesTitle;
